import React, {Fragment, useContext} from "react";
import {Link, useNavigate} from "react-router-dom";
import {
  Box,
  Chip,
  Divider,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Typography,
} from "@mui/material";

import gift from "../../../assets/images/gift.svg";
import logout from "../../../assets/images/logout.svg";
import {
  DiscordIcon,
  FacebookIcon,
  InstagramIcon,
  TwitterIcon,
  AccountIcon,
  GotoIcon,
  ProfileIcon,
  SecurityPrivacyIcon,
  PayoutsIcon,
  NotificationsIcon,
  SubscriptionsIcon,
  BillingIcon,
  ReferralLinksIcon,
} from "../../../assets/svgFile";
import "./settingSidebar.css";
import {useVarAuth} from "../../../graphql/graphql/auth/defaults";
import {MenuContext} from "../../../contexts/menuContext";
import {BackSetitngButton} from "../../../components/BackSettinButton";
import profileImg from "../../../assets/images/profileImg.svg";
import moment from "moment";

const userSetting = [
  {
    name: "My Account",
    chip: "",
    icon: <AccountIcon />,
    route: "/settings/myaccount",
  },
  {
    name: "Profile",
    chip: "",
    icon: <ProfileIcon />,
    route: "/settings/profile",
  },
  {
    name: "Privacy & Safety",
    chip: "",
    icon: <SecurityPrivacyIcon />,
    route: "/settings/privacy-safety",
  },
];

const earnMoney = [
  {
    name: "Payouts",
    chip: "0",
    icon: <PayoutsIcon />,
    route: "/settings/payouts",
  },
  {
    name: "Referral Links",
    chip: "",
    icon: <ReferralLinksIcon />,
    route: "/settings/referral-links",
  },
  // {
  //   name: "Your Referrals",
  //   chip: "10",
  //   icon: "",
  // },
  // {
  //   name: "Promo Material",
  //   chip: "",
  //   icon: "",
  //   route: "/settings/promo-material",
  // },
];

const notifSetting = [
  {
    name: "Notifications",
    chip: "",
    icon: <NotificationsIcon />,
    route: "/settings/notifications",
  },
];

const billingSetting = [
  {
    name: "My Subscriptions",
    chip: "",
    icon: <SubscriptionsIcon />,
    route: "/settings/subscriptions",
  },
  {
    name: "Billing",
    chip: "",
    icon: <BillingIcon />,
    route: "/settings/billing",
  },
  // {
  //   name: "Premium Plans",
  //   chip: "",
  //   icon: "",
  //   route: "/settings/premium-plans",
  // },
  // {
  //   name: "Send Gift",
  //   chip: "",
  //   icon: gift,
  //   route: "/settings/send-gift",
  // },
];

// const newUpdates = [
//   {
//     name: "New Updates",
//     chip: "",
//     icon: "",
//   },
//   {
//     name: "#HashTag",
//     chip: "",
//     icon: "",
//   },
//   {
//     name: "#HashTag1",
//     chip: "",
//     icon: "",
//   },
// ];

const logoutMenu = [
  {
    name: "Log Out",
    icon: logout,
  },
];

const socialIcons = [
  //{url: "", icon: <TwitterIcon />},
  //{url: "", icon: <FacebookIcon />},
  //{url: "", icon: <InstagramIcon />},
  {url: "https://discord.gg/buythedip", icon: <DiscordIcon />},
];

const SettingSidebar = () => {
  const {logout, user = {}} = useVarAuth();
  const {open, setOpen, isSmall} = useContext(MenuContext);

  const navigate = useNavigate();

  const renderMenu = (menu, index) => (
    <Fragment key={index}>
      <ListItem
        disablePadding
        className={
          (!isSmall && window.location.pathname === "/settings" && menu?.route === userSetting[0].route) ||
          menu?.route === window.location.pathname
            ? "activeMenu"
            : ""
        }
        onClick={() => navigate(menu?.route)}
        sx={isSmall ? {mt: "1px", paddingX: "15px", background: "#141414"} : {mt: 1}}
      >
        {isSmall && menu?.icon}
        <ListItemButton>
          <ListItemText primary={menu?.name} />
          {menu?.chip !== "" && <Chip label={menu?.chip} />}
        </ListItemButton>
        {isSmall && <GotoIcon />}
      </ListItem>
    </Fragment>
  );

  //console.log("user", user);
  return (
    <Box className="settingMenu">
      {isSmall && (
        <>
          <BackSetitngButton label={"Go Back To Home"} />
          <Box
            display={"flex"}
            gap={"16px"}
            alignItems="center"
            background="linear-gradient(0deg, rgba(237, 160, 68, 0.05), rgba(237, 160, 68, 0.05)), #0F0F0F"
            padding="18px 8px"
          >
            <img src={user.avatar || profileImg} alt="profile" className="imgProfile" />
            <Box>
              <Typography variant="body1">{user.name}</Typography>
              <Typography variant="body2" color={"rgba(255, 255, 255, 0.6)"}>
                Member Since {moment(user?.createdAt).format("MMM YYYY")}
              </Typography>
            </Box>
          </Box>
        </>
      )}

      <Box className="settingSideWrap" p={isSmall ? 0 : "42px 16px 16px"}>
        <Typography variant="h6">User settings</Typography>
        <List>{userSetting?.map((menu, index) => renderMenu(menu, index))}</List>
        {!isSmall && <Divider />}
        <Typography variant="h6">earn real money</Typography>
        <List>{earnMoney?.map((menu, index) => renderMenu(menu, index))}</List>
        {!isSmall && <Divider />}
        <Typography variant="h6">Notif settings</Typography>
        <List>{notifSetting?.map((menu, index) => renderMenu(menu, index))}</List>
        {!isSmall && <Divider />}
        <Typography variant="h6">Billing settings</Typography>
        <List>{billingSetting?.map((menu, index) => renderMenu(menu, index))}</List>
        {/* <Divider />
        <List>{newUpdates?.map((menu, index) => renderMenu(menu, index))}</List> */}
        {!isSmall && <Divider />}
        <List>
          {logoutMenu.map((menu, key) =>
            isSmall ? (
              <ListItem key={key} disablePadding onClick={logout}>
                <ListItemButton
                  sx={{
                    alignItems: "center",
                    justifyContent: "center",
                    height: "40px",
                    gap: "9px",
                    backgroundColor: "rgba(122, 39, 26, 0.6)",
                    fontWeight: 500,
                    marginTop: "20px",
                  }}
                >
                  {/* <ListItemText primary={menu?.name} /> */}
                  {menu?.name}
                  {/* <ListItemIcon sx={{justifyContent: "flex-start"}}> */}
                  <img src={menu?.icon} alt="logout" />
                  {/* </ListItemIcon> */}
                </ListItemButton>
              </ListItem>
            ) : (
              <ListItem key={key} disablePadding onClick={logout}>
                <ListItemButton>
                  <ListItemText primary={menu?.name} />
                  <ListItemIcon sx={{justifyContent: "flex-end"}}>
                    <img src={menu?.icon} alt="logout" />
                  </ListItemIcon>
                </ListItemButton>
              </ListItem>
            )
          )}
        </List>
        {!isSmall && <Divider />}
        <Box className="socialIcons" display="flex" justifyContent={isSmall ? "center" : "flex-start"} mt={2} mb={3}>
          {socialIcons.map((social, key) => (
            <a href ={social.url} key={key} target='_blank' rel='noopener noreferrer'>
              {social.icon}
            </a>
          ))}
        </Box>
        <Box className="websiteText" textAlign={isSmall ? "center" : "left"}>
          <Link to="">{window.location.hostname}</Link>
        </Box>
      </Box>
    </Box>
  );
};

export default SettingSidebar;
